export class Logs {
  constructor(instance) {
    this.instance = instance;
  }

  getLogs(filters) {
    const filtredParams = filters ? { ...filters } : {};

    delete filtredParams?.initial;

    return this.instance.get('/v1/logs', {
      params: filtredParams,
    });
  }
}

export default (...params) => new Logs(...params);
